<template>
  <el-scrollbar class="linkTree left-tree">
    <el-tree
        show-checkbox
        :props="controlCenterProps"
        ref="searchTree"
        :data="searchData"
        node-key="thirdDeviceId"
        :default-expand-all="true"
        :render-content="renderContent"
        style="margin-bottom: 12px;"
        @check="nodeCheck"/>
  </el-scrollbar>
</template>

<script>

export default {
  name: 'link-left-tree',
  props: {
    deviceType: {
      type: String,
      default: () => ''
    },
    deviceName: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    deviceName: function (newVal) {
      console.log('🚀 ~ file: link-left-tree.vue ~ line 50 ~ newVal', newVal)
      this.handleSearchTree()
    },
    deviceType: function () {
      console.log(
          '🚀 ~ file: link-left-tree.vue ~ line 57 ~ deviceType ~ deviceType',
          this.deviceType
      )
      this.handleSearchTree()
    }
  },
  data() {
    return {
      searchData: [],
      rootData: [],
      selectedData: [],
      positions: [],
      controlCenterProps: {
        children: 'subTreeModelList',
        label: 'name',
        disabled: 'readOnly'
      },
      renderContent: (h, {node, data, store}) => {
        let iconClass = ''
        if (!node.data.deviceType) {
          if (node.level === 2) {
            iconClass = 'soc iconLevelOne'
          } else if (node.level === 3) {
            iconClass = 'soc iconLevelTwo'
          } else {
            iconClass = 'soc iconLevelThree'
          }
        } else {
          iconClass = this.switchCameraIcon(node.data.deviceType)
        }
        this.$set(data,'readOnly',!node.data.deviceType)
        return h(
            'div',
            {
              attrs: {class: 'clickClass'}
            },
            [
              h('i', {
                attrs: {class: iconClass}
              }),
              h('span', {style: {marginLeft: '10px'}}, node.label)
            ]
        )
      }
    }
  },
  mounted() {
    this.handleSearchTree()
  },
  methods: {
    nodeCheck(node, arr) {
      console.log('信息', node, arr)
      this.selectedData = arr.checkedNodes.filter(item => item.deviceType)
      this.$emit('handleTreeSelect', this.selectedData)
      console.log('选中的设备', this.selectedData)
    },
    /**
     * 获取图标
     * @param val
     * @return {string}
     */
    switchCameraIcon(val) {
      switch (val) {
        case '1101':
          return 'soc iconGunMachine device'
        case '1102':
          return 'soc iconGunMachine device'
        case '1103':
          return 'soc iconBallMachine device'
        case '1104':
          return 'soc iconHalfMachine device'
        case '1105':
          return 'soc iconGunMachine device'
      }
    },
    handleSearchTree() {
      let param = {
        deviceName: this.deviceName,
        deviceMarkList: [this.deviceType],
        authorityFlag: 1
      }
      this.$fetch('/bms/device/queryAreaDeviceTree.json', param).then(res => {
        if (!res.success) {
          return
        }
        if (!res.returnObj) {
          this.searchData = []
          return
        }
        this.searchData = Object.freeze(res.returnObj)
      })
    }
  }
}
</script>

<style lang="scss">
.linkTree {
  border: 1px solid rgba(88, 101, 131, 0.3);
  margin: 10px;
  height: 350px;
}

.clickClass {
  .iconBallMachine {
    font-size: 12px;
  }

  .device {
    font-size: 14px;
  }
}

.left-tree {

  -ms-overflow-style: scrollbar !important;
  scrollbar-arrow-color: #407aee !important; /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #407aee !important; /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #272f4a !important; /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #272f4a !important; /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #272f4a !important; /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #272f4a !important; /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #272f4a !important; /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #272f4a !important; /**/
  /*滚动条的基本颜色*/

  .el-tree-node .el-tree-node__content:before {
    margin-left: 20px !important;
    margin-top: -19px !important;
  }

  .el-tree-node {
    position: relative;
  }

  .el-tree-node__content > .el-tree-node__expand-icon {
    padding-left: 33px !important;
  }

  .el-tree > .el-tree-node > .el-tree-node__content:first-child {
    &::before,
    &::after {
      border: none;
    }
  }

  .el-checkbox__inner {
    border-radius: 0;
    border: 1px solid #586583;
    // background: #202945 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #407aee !important;
    border-color: #407aee;
  }

  .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #edf2fc !important;
    border-color: #dcdfe6;
    border-width: 0 !important;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    display: none;
  }

  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-width: 4px;
  }

  .el-tree-node__content .is-leaf:before {
    content: '';
    border: 0 solid #8696b5;
    width: 3px;
    margin-right: 0;
  }

  .el-tree-node__children .el-icon-caret-right:after {
    content: '';
    position: absolute;
    display: inline-block;
    height: 1px;
    width: 8px;
    left: -11px;
    top: 5px;
    background-color: #62687d;
  }

  .el-tree-node__children .el-icon-caret-right:after {
    left: 20px !important;
  }

  .el-tree-node .el-tree-node__content:before {
    margin-left: 20px !important;
    margin-top: -19px !important;
  }

  .el-tree-node .el-tree-node__content:before {
    content: '';
    position: absolute;
    right: auto;
    border-left: 1px solid #62687d;
    bottom: 50px;
    height: 100%;
    top: 0;
    width: 1px;
    margin-left: -11px;
    margin-top: -18px;
    z-index: 1;
  }

  .el-tree .is-current > .el-tree-node__content {
    background: linear-gradient(
            to right,
            rgb(56, 102, 491),
            rgb(46, 76, 140),
            rgb(38, 62, 105),
            transparent
    );
    background: -ms-linear-gradient(left, #294078, var(--park-component-bg-color));
    background: -webkit-linear-gradient(left, #294078, var(--park-component-bg-color));
    background: -moz-linear-gradient(left, #294078, var(--park-component-bg-color));
  }

  .el-tree .el-tree-node > .el-tree-node__content:hover {
    background: rgba(70, 82, 117, 0.4);
  }

  .el-tree > .el-tree-node {
    min-width: 100%;
    display: inline-block;
  }

  .el-tree-node__content > .el-tree-node__expand-icon {
    transform: rotate(0deg) !important;
    padding: 0;
    font-family: 'soc' !important;
    font-size: 12px;
    font-style: normal;
  }

  .el-icon-caret-right:before {
    content: '\e69c';
    display: inline-block;
    border: 1px solid hsla(0, 0%, 100%, 0.3);
    width: 13px;
    height: 13px;
    margin-right: 6px;
    line-height: 13px;
    text-align: center;
    color: hsla(0, 0%, 100%, 0.3);
    margin-top: -2px;
  }

  .expanded.el-icon-caret-right:before {
    content: '\e69d';
    display: inline-block;
    border: 1px solid hsla(0, 0%, 100%, 0.3);
    width: 13px;
    height: 13px;
    margin-right: 6px;
    line-height: 13px;
    text-align: center;
    color: #407aee;
  }

  .el-tree .el-tree-node {
    .el-tree-node__content {
      height: 36px !important;

      .clickClass {
        width: 100%;
        display: flex;
        align-items: center;
        height: 36px;
        padding-right: 36px;

        &.off_line {
          color: rgba(#fff, 0.4);

          .typeIcon {
            color: rgba(#fff, 0.4);
          }

          .ellipsis_text {
            color: rgba(#fff, 0.4) !important;
          }

          .attrType_icon {
            position: absolute;
            right: 3px;
            top: 0;
            font-size: 24px;
            line-height: 36px;
          }
        }

        .typeIcon {
          margin-right: 5px;
          color: #fff;
          font-size: 20px;
        }

        .ellipsis_text {
          margin-right: 25px;
          color: #fff;
        }

        .attrType_icon {
          position: absolute;
          right: 0;
          top: 0;
          font-size: 24px;
          line-height: 36px;
        }

        .online_text {
          color: #8696b5;
        }
      }
    }
  }
}
</style>
